import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../styles/auth.css';

export const RegisterView: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [name, setName] = useState('');
  const [tenant, setTenant] = useState('');
  const [secret, setSecret] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  // Clear sensitive credentials from component state
  const clearCredentials = () => {
    setPassword('');
    setConfirmPassword('');
    setSecret('');
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setIsLoading(true);

    try {
      await register(username, password, name, tenant, secret);
      clearCredentials();
      navigate('/');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Registration failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-box">
          <h2>New User Registration</h2>
          <p className="auth-description">
            Create a new account. If you already have an account, use "Add Tenant" instead.
          </p>
          {error && <div className="error-message">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="username">Email</label>
              <input
                type="email"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="name">Full Name</label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="confirmPassword">Confirm Password</label>
              <input
                type="password"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="tenant">Tenant</label>
              <input
                type="text"
                id="tenant"
                value={tenant}
                onChange={(e) => setTenant(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="secret">Registration Code</label>
              <input
                type="text"
                id="secret"
                value={secret}
                onChange={(e) => setSecret(e.target.value)}
                required
                placeholder="Enter the registration code for this tenant"
              />
            </div>
            <button type="submit" disabled={isLoading}>
              {isLoading ? 'Registering...' : 'Register'}
            </button>
          </form>
          <div className="auth-links">
            <a href="/login">Already have an account? Login</a>
            <br /><br />
            <a href="/add-tenant">Need access to another tenant? Add Tenant</a>
          </div>
        </div>
      </div>
    </div>
  );
}; 